module.exports = __webpack_public_path__ + "img/农民工工资保函.50af79c1.png";